import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8c9a140"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid d-flex flex-column p-1 gap-5",
  style: {"overflow-x":"scroll"}
}
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0 largura-minima" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-search"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "white",
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "white",
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"18px"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_9 = { class: "d-flex flex-row align-items-center gap-4 w-100" }
const _hoisted_10 = {
  style: {"width":"40rem"},
  class: "d-flex flex-column gap-2"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  style: {"border-radius":"7.5px","background":"#e4e4e4"},
  class: "p-3"
}
const _hoisted_13 = {
  style: {"width":"40rem !important"},
  class: "d-flex flex-column"
}
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = {
  style: {"white-space":"nowrap"},
  class: "m-0 texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_16 = { class: "d-flex justify-content-between" }
const _hoisted_17 = { class: "d-flex gap-1 align-items-start" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Marca:", -1))
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "d-flex gap-1 justify-content-center align-items-start" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Fipe:", -1))
const _hoisted_22 = {
  style: {"white-space":"nowrap"},
  class: "m-0 texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_23 = { class: "d-flex gap-1 justify-content-center align-items-start" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Ano:", -1))
const _hoisted_25 = {
  style: {"white-space":"nowrap"},
  class: "m-0 texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_26 = { class: "painel-filtros" }
const _hoisted_27 = { class: "m-0 texto bold cor_texto_1" }
const _hoisted_28 = {
  key: 2,
  class: "texto cor_texto_1 text-center m-0"
}
const _hoisted_29 = {
  class: "d-flex align-items-center justify-content-center",
  id: "load"
}
const _hoisted_30 = {
  key: 0,
  style: {"color":"#dc3545"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_EditaCaminhao = _resolveComponent("EditaCaminhao")!
  const _component_AdicionarCaminhao = _resolveComponent("AdicionarCaminhao")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_Title, {
            description: `${_ctx.resultados || 0} resultados`
          }, {
            default: _withCtx(() => [
              _createTextVNode("Caminhões")
            ]),
            _: 1
          }, 8, ["description"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Filtre por veículo ou fipe",
            modelValue: _ctx.fastFind,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fastFind) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.buscaRapida()), ["enter"])),
            onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscaRapida()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            type: "button",
            variant: "secondary",
            text: "Buscar",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscaRapida())),
            style: {"white-space":"nowrap"}
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "button",
            text: "Voltar",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.history.back()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "button",
            variant: "secondary",
            text: "Editar Múltiplos",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mudaEditarMultiplos())),
            style: _normalizeStyle([{"white-space":"nowrap"}, `opacity: ${_ctx.editarMultiplos ? 1 : 0.3}`])
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Button, {
            type: "button",
            variant: "secondary",
            text: "Abrir edição",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editarMultiplos && _ctx.veiculosSelecionado.length >= 2 && _ctx.abreVeiculoModal())),
            style: _normalizeStyle([{"white-space":"nowrap"}, `opacity: ${_ctx.editarMultiplos && _ctx.veiculosSelecionado.length >= 2 ? 1 : 0.3}`])
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Button, {
            type: "button",
            variant: "secondary",
            text: "Adicionar caminhão",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.abreAdicionarVeiculoModal())),
            style: {"white-space":"nowrap"}
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.buscandoVeiculos)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
            return _createElementVNode("div", {
              key: `skeleton-${n}`,
              class: "card card-veiculo largura-minima justify-content-start align-items-center p-3 w-100"
            }, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                class: "w-100"
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "image",
                      class: "skeleton-icone"
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"55%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"80%"}
                      })
                    ]),
                    _createVNode(_component_el_skeleton_item, {
                      variant: "p",
                      class: "skeleton-painel"
                    })
                  ])
                ]),
                _: 1
              })
            ])
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.vehiclesArray, (vehicle, i) => {
            return (_openBlock(), _createElementBlock("section", {
              key: vehicle.id ?? i,
              onClick: () => (_ctx.editarMultiplos ? _ctx.selecionaVeiculo(vehicle) : _ctx.escolheVeiculo(vehicle)),
              class: _normalizeClass(["card card-veiculo largura-minima justify-content-start align-items-center p-3 cursor-pointer w-100", { 'card-veiculo--selecionado': vehicle.selecionado }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_inline_svg, {
                  src: "media\\icons\\duotune\\general\\car.svg",
                  style: {"width":"24px","height":"24px"}
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("section", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(vehicle.modelo || "-"), 1)
                ]),
                _createElementVNode("section", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", {
                      style: {"white-space":"nowrap","width":"60px"},
                      title: vehicle.marca,
                      class: "m-0 texto cor_texto_1 d-inline-block text-truncate"
                    }, _toDisplayString(vehicle.marca || "-"), 9, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, _toDisplayString(vehicle.fipe || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("p", _hoisted_25, _toDisplayString(vehicle.ano2 || "-"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtrosVeiculo, (filtro) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: filtro.chave,
                    class: "painel-filtros__item"
                  }, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(filtro.label), 1),
                    _createElementVNode("p", {
                      class: _normalizeClass(["m-0 px-3 py-1 text-white fs-4 contador-filtro", filtro.destacaSempre || Number(vehicle[filtro.chave]) > 0 ? 'btn-danger' : 'contador-filtro--vazio'])
                    }, _toDisplayString(Number(vehicle[filtro.chave]) || 0), 3)
                  ]))
                }), 128))
              ])
            ], 10, _hoisted_11))
          }), 128)),
      (_ctx.primeiraBuscaFeita && !_ctx.vehiclesArray.length && !_ctx.vehicleLoad && !_ctx.buscandoVeiculos)
        ? (_openBlock(), _createElementBlock("p", _hoisted_28, " Nenhum caminhão encontrado "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handlePage(_ctx.page ? _ctx.page + 1 : 1))),
          style: {"width":"15rem","height":"3.2rem"},
          class: "card d-flex flex-row gap-2 justify-content-center align-items-center cursor-pointer"
        }, [
          (_ctx.vehicleLoad)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.vehicleLoad ? "Carregando mais" : "Carregar mais"), 1)
        ], 512), [
          [_vShow, !_ctx.buscandoVeiculos]
        ])
      ])
    ]),
    _createVNode(_component_EditaCaminhao, {
      fechaModal: _ctx.fechaVeiculoModal,
      veiculos: _ctx.veiculosSelecionado
    }, null, 8, ["fechaModal", "veiculos"]),
    _createVNode(_component_AdicionarCaminhao)
  ]))
}